import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';
import { GlobalPermissionsModel } from '@nimbus-global/features/permissions/models/global-permissions.model';

export function createGlobalPermissionsModelGuard(action: (model: GlobalPermissionsModel) => boolean): CanActivateFn {
  return (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
    const permissionManagerService = inject(IPermissionManagerService);
    const router = inject(Router);
    const fallbackUrl = (route.data.fallbackUrl as string[]) ?? ['/'];

    return permissionManagerService
      .getGlobalPermissionsModel$()
      .pipe(map((model) => (action(model) ? true : router.createUrlTree(fallbackUrl))));
  };
}
